// @flow

import React from "react";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import SortableItem from "./SortableItem";
import { SortableList as StyledSortableList } from "./styles";

type Props = {
  items: Array<number>,
  handleOpenModal: Function,
};

const SortableList = ({ items, handleOpenModal }: Props) => {
  return (
    <SortableContext items={items} strategy={verticalListSortingStrategy}>
      <StyledSortableList>
        {(items || []).map((value) => (
          <SortableItem
            key={`item-${value}`}
            id={value}
            handleOpenModal={handleOpenModal}
          />
        ))}
      </StyledSortableList>
    </SortableContext>
  );
};

export default SortableList;
